import React from 'react';
import Avatar from 'shared/components/avatar/Avatar';
import { firstLetters } from 'utils/strings';
import { Link } from 'react-router-dom';

const ItemProgress = props => {
  const {
    avatarImage,
    name,
    period,
    avatarUrl,
    clientId,
    title,
    progressImage1,
    progressImage2,
    progressImage3
  } = props;

  return (
    <div className="timeline-item">
      <Avatar
        src={avatarImage}
        width="32"
        height="32"
        name={name}
        text={`${period} ago`}
        firstLetters={firstLetters(name)}
        url={avatarUrl}
      />
      <div className="activity-info">
        <Link to={`/clients/${clientId}/progress-photos`}>{title}</Link>
      </div>
      <div className="progress-img">
        <div>
          { progressImage1 ?
            <img src={progressImage1} alt="Progress" /> :
            'No first Photo uploaded!'
          }
        </div>
        <div>
          { progressImage2 ?
            <img src={progressImage2} alt="Progress" /> :
            'No second Photo uploaded!'
          }
        </div>
        <div>
          { progressImage3 ?
            <img src={progressImage3} alt="Progress" /> :
            'No third Photo uploaded!'
          }
        </div>
      </div>
    </div>
  );
};

export default ItemProgress;
